// Tree widget: renders a containment tree from { roots: Entity[], childrenOf: (id) => Entity[] }.

import { useState } from "react";
import type { Entity } from "@viz/types";
import type { WidgetComponent } from "@viz/presentation";

const Tree: WidgetComponent = ({ props, onDrill }) => {
  const roots = (props.roots as Entity[] | undefined) ?? [];
  const childrenOf = (props.childrenOf as ((id: string) => Entity[]) | undefined);
  return (
    <ul className="text-sm leading-tight">
      {roots.map(r => <Node key={r.id} entity={r} childrenOf={childrenOf} onDrill={onDrill} depth={0} />)}
    </ul>
  );
};

function Node({ entity, childrenOf, onDrill, depth }:
  { entity: Entity; childrenOf: ((id: string) => Entity[]) | undefined; onDrill?: (id: string) => void; depth: number }) {
  const [open, setOpen] = useState(depth < 2);
  const kids = childrenOf?.(entity.id) ?? [];
  return (
    <li className="my-px">
      <div className="flex items-center gap-1 rounded px-1 py-0.5 hover:bg-slate-100">
        {kids.length > 0 ? (
          <button onClick={() => setOpen(o => !o)} className="h-4 w-4 text-slate-500">{open ? "▾" : "▸"}</button>
        ) : <span className="h-4 w-4" />}
        <button className="font-mono text-xs text-sky-700 hover:underline" onClick={() => onDrill?.(entity.id)}>
          {String(entity.props.name?.value ?? entity.id)}
        </button>
        <span className="text-[10px] uppercase tracking-wider text-slate-500">{entity.type}</span>
      </div>
      {open && kids.length > 0 && (
        <ul className="ml-4 border-l border-slate-200 pl-2">
          {kids.map(k => <Node key={k.id} entity={k} childrenOf={childrenOf} onDrill={onDrill} depth={depth + 1} />)}
        </ul>
      )}
    </li>
  );
}

export default Tree;
